/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_not_found_description = /** @type {(inputs: {}) => string} */ () => {
	return `Lo sentimos, la página que buscas no existe o ha sido movida.`
};

const en_not_found_description = /** @type {(inputs: {}) => string} */ () => {
	return `Sorry, the page you're looking for doesn't exist or has been moved.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const not_found_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.not_found_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("not_found_description", locale)
	if (locale === "es") return es_not_found_description(inputs)
	return en_not_found_description(inputs)
};
export { not_found_description as "not_found.description" }